export default "__VITE_PUBLIC_ASSET__b7088ce1__"